import { is } from "date-fns/locale";
import { create } from "zustand";

export const useEventosStore = create((set) => ({
  logsName: [],
  logNameSelect: "",
  selectedEvent: "user", // valor por defecto
  selectedSubject: "App\\Models\\ActasFotoMulta", // valor por defecto
  detalleEvent: null,
  actaBuscar: null,
  usuarioBuscar: null,
  isLoad: false,
  userActivity: [],
  errorActivity: [],
  eventos: [],
  eventosActa: [],
  eventosFiltrados: [],

  setIsLoad: (isLoad) => {
    set({ isLoad: isLoad });
  },
  setUserActivity: (userActivity) => {
    set({ userActivity: userActivity });
  },

  setErrorActivity: (errorActivity) => {
    set({ errorActivity: errorActivity });
  },

  setEventos: (eventos) => {
    set({ eventos: eventos, eventosFiltrados: eventos });
  },

  setEventosActa: (eventos) => {
    set({ eventosActa: [] });
    set({ eventosActa: eventos });
  },

  setFilteredEventos: (eventos) => {
    set({ eventosFiltrados: eventos });
  },

  setLogNameSelect: (logName) => {
    set({ logNameSelect: logName });
  },

  setActaBuscar: (acta) => {
    set({ actaBuscar: acta });
  },

  setUsuarioBuscar: (usuario) => {
    set({ usuarioBuscar: usuario });
  },

  setSelectedEvent: (event) => {
    event === "user" && set({ selectedSubject: "", eventos: [], eventosFiltrados: [] });
    event === "error" && set({ selectedSubject: "", eventos: [], eventosFiltrados: [] });
    event === "job" && set({ selectedSubject: "", eventos: [], eventosFiltrados: [] });

    set({ selectedEvent: event });
  },

  setSelectedSubject: (subject) => {
    set({ selectedSubject: subject, eventos: [], eventosFiltrados: [] });
  },

  setLogsName: (logsName) => {
    set({ logsName: logsName });
  },

  addNewEvents: (eventos, log_name, subject_type) =>
    set((state) => {
      // si el logname y subject type son iguales a los seleccionados se agregan los eventos
      if (
        log_name === state.selectedEvent &&
        subject_type === state.selectedSubject &&
        eventos.length > 0
      ) {
        const filteredEventos = eventos.filter(
          (newEvent) => !state.eventos.some((event) => event.id === newEvent.id)
        );

        // aca es necesario ordenar los ids ya que se puede desordenar al agregar nuevos eventos
        const newEventos = [...state.eventos, ...filteredEventos].sort((a, b) => b.id - a.id);

        if (newEventos.length > 500) {
          return { eventos: newEventos.slice(-500) };
        }
        return { eventos: newEventos, eventosFiltrados: newEventos };
      }

      // si el logname y subject type son iguales a los seleccionados y no hay eventos se retornan los eventos actuales
      if (
        log_name === state.selectedEvent &&
        subject_type === state.selectedSubject &&
        eventos.length === 0
      ) {
        return { eventos: state.eventos, eventosFiltrados: state.eventosFiltrados };
      }

      // sino, si cambio el logname o el subject type se limpian los eventos y se agregan los nuevos
      state.eventosActa = [];
      const newEventos = eventos.length > 500 ? eventos.slice(-500) : eventos;
      return { eventos: newEventos, eventosFiltrados: newEventos };
    }),

  addTotalEvents: (eventos) =>
    set((state) => {
      state.eventosActa = [];
      const newEventos = eventos;
      return { eventos: newEventos, eventosFiltrados: newEventos };
    }),

  addEvents: (eventos, name) =>
    set((state) => {
      if (name == "user") {
        const filteredEventos = eventos.filter(
          (newEvent) => !state.userActivity.some((event) => event.id === newEvent.id)
        );

        const newEventos = [...state.userActivity, ...filteredEventos].sort((a, b) => b.id - a.id);

        if (newEventos.length > 500) {
          return { userActivity: newEventos.slice(-500) };
        }
        return { userActivity: newEventos };
      }

      if (name == "error") {
        const filteredEventos = eventos.filter(
          (newEvent) => !state.errorActivity.some((event) => event.id === newEvent.id)
        );

        const newEventos = [...state.errorActivity, ...filteredEventos].sort((a, b) => a.id - b.id);

        if (newEventos.length > 500) {
          return { errorActivity: newEventos.slice(-500) };
        }
        return { errorActivity: newEventos };
      }
    }),

  addEventosActa: (eventos, actaID) =>
    set((state) => {
      // si actaID es igual al que hay en todos los eventosActa se agregan los eventos
      if (actaID === state.eventosActa[0]?.acta_id && eventos.length > 0) {
        const filteredEventos = eventos.filter(
          (newEvent) => !state.eventosActa.some((event) => event.id === newEvent.id)
        );

        // aca es necesario ordenar los ids ya que se puede desordenar al agregar nuevos eventos
        const newEventos = [...state.eventosActa, ...filteredEventos].sort((a, b) => b.id - a.id);

        if (newEventos.length > 500) {
          return { eventosActa: newEventos.slice(-500) };
        }
        return { eventosActa: newEventos };
      }

      // si actaID es igual al que hay en todos los eventosActa ay no hay eventos se retornan los eventos actuales
      if (
        actaID === state.eventosActa[0]?.acta_id &&
        eventos.length === 0 &&
        state.eventosActa.length > 0
      ) {
        return { eventosActa: state.eventosActa };
      }

      // sino, si cambio el actaID al que ya hay se limpian los eventos y se agregan los nuevos
      state.eventosActa = [];
      const newEventos = eventos.length > 500 ? eventos.slice(-500) : eventos;
      return { eventosActa: newEventos };
    }),

  setDetalleEvent: (detalle) => {
    set({ detalleEvent: detalle });
  },
}));
